
/* injects from baggage-loader */

'use strict';

import userTemplate from '!!file-loader?name=templates/[name].[ext]!./user.html';

/**
 * Function that register the all routes for the module.
 *
 * @param {any} $q
 * @param {any} $ocLazyLoad
 * @param {any} routerHelper
 * @param {any} navigationConstant
 */
function routeConfig($q, $ocLazyLoad, routerHelper, navigationConstant) {
	'ngInject';

	/**
	 * Route definition of the management user page.
	 */
	const indexNav = 5;
	const userRoute = {
		state: navigationConstant.RESOURCES[indexNav].STATE,
		config: {
			url: navigationConstant.RESOURCES[indexNav].URL,
			templateUrl: userTemplate,
			controller: 'UserController',
			controllerAs: 'uservm',
			resolve: {
				user: userLazyLoading
			},
			data: {
				code: navigationConstant.RESOURCES[indexNav].CODE,
				login: true,
				pageTitle: navigationConstant.RESOURCES[indexNav].NAME,
				submenu: false
			},
		}
	};

	routerHelper.configureStates([userRoute]);
}

/**
 * Function for the lazyLoading configuration  route.
 *
 * @param {any} $q
 * @param {any} $ocLazyLoad
 * @returns
 */
function userLazyLoading($q, $ocLazyLoad) {
	'ngInject';

	const deferred = $q.defer();

	require.ensure([], require => {
		const userModule = require('./user.module.js');

		$ocLazyLoad.load({
			name: userModule.default.name,
		});

		deferred.resolve(userModule.default.controller);
	});

	return deferred.promise;
}

export default angular
	.module('user.routes', [])
	.run(routeConfig);



// WEBPACK FOOTER //
// ./src/app/auth/management/user/user.routes.js